import StatCard from "pages/dashboard-overview/components/StatCard";
import { EXPENSE_CATEGORY_META } from "constants/expenseConstants";

const formatCurrency = (value) =>
  `$${Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export default function CategoryBreakdownCards({ breakdown }) {
  if (!breakdown) return null;

  return (
    <div className="px-4 pb-4">
      <h3 className="text-sm font-medium text-gray-700 mb-3">Category Breakdown</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {EXPENSE_CATEGORY_META.map(({ key, label }) => (
          <StatCard
            key={key}
            title={label}
            value={formatCurrency(breakdown[key] ?? 0)}
            icon="Layers"
          />
        ))}
      </div>
    </div>
  );
}
